"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClient = void 0;
// CC
const auth_management_shared_1 = require("./services/cc/auth-management/auth-management.shared");
const ballots_shared_1 = require("./services/cc/ballots/ballots.shared");
const barcode_shared_1 = require("./services/cc/barcode/barcode.shared");
const districts_shared_1 = require("./services/cc/districts/districts.shared");
const election_matrixes_shared_1 = require("./services/cc/election-matrixes/election-matrixes.shared");
const election_metrics_shared_1 = require("./services/cc/election-metrics/election-metrics.shared");
const electrack_shared_1 = require("./services/cc/electrack/electrack.shared");
const epms_component_shared_1 = require("./services/cc/epms-component/epms-component.shared");
const epms_order_shared_1 = require("./services/cc/epms-order/epms-order.shared");
const epms_shipment_shared_1 = require("./services/cc/epms-shipment/epms-shipment.shared");
const file_maker_shared_1 = require("./services/cc/file-maker/file-maker.shared");
const file_uploads_shared_1 = require("./services/cc/file-uploads/file-uploads.shared");
const inventory_shared_1 = require("./services/cc/inventory/inventory.shared");
const lockouts_shared_1 = require("./services/cc/lockouts/lockouts.shared");
const reports_shared_1 = require("./services/cc/reports/reports.shared");
// EPMS
const contact_shared_1 = require("./services/epms/contact/contact.shared");
const cost_center_shared_1 = require("./services/epms/cost-center/cost-center.shared");
const customer_shared_1 = require("./services/epms/customer/customer.shared");
const customer_ship_to_shared_1 = require("./services/epms/customer-ship-to/customer-ship-to.shared");
const department_shared_1 = require("./services/epms/department/department.shared");
const diary_note_shared_1 = require("./services/epms/diary-note/diary-note.shared");
const employee_shared_1 = require("./services/epms/employee/employee.shared");
const estimate_header_shared_1 = require("./services/epms/estimate-header/estimate-header.shared");
const location_shared_1 = require("./services/epms/location/location.shared");
const material_on_hand_shared_1 = require("./services/epms/material-on-hand/material-on-hand.shared");
const order_component_shared_1 = require("./services/epms/order-component/order-component.shared");
const order_header_shared_1 = require("./services/epms/order-header/order-header.shared");
const order_process_shared_1 = require("./services/epms/order-process/order-process.shared");
const production_shared_1 = require("./services/epms/production/production.shared");
const production_job_number_shared_1 = require("./services/epms/production-job-number/production-job-number.shared");
// ET
const audit_shared_1 = require("./services/et/audit/audit.shared");
const counties_shared_1 = require("./services/et/counties/counties.shared");
const elections_shared_1 = require("./services/et/elections/elections.shared");
const jobs_shared_1 = require("./services/et/jobs/jobs.shared");
const maps_shared_1 = require("./services/et/maps/maps.shared");
// PGE
const activity_logs_shared_1 = require("./services/pge/activity-logs/activity-logs.shared");
const app_settings_shared_1 = require("./services/pge/app-settings/app-settings.shared");
const ballot_types_shared_1 = require("./services/pge/ballot-types/ballot-types.shared");
const district_sheets_shared_1 = require("./services/pge/district-sheets/district-sheets.shared");
const districts_shared_2 = require("./services/pge/districts/districts.shared");
const election_ballots_shared_1 = require("./services/pge/election-ballots/election-ballots.shared");
const election_matrixes_shared_2 = require("./services/pge/election-matrixes/election-matrixes.shared");
const election_parties_shared_1 = require("./services/pge/election-parties/election-parties.shared");
const elections_shared_2 = require("./services/pge/elections/elections.shared");
const electrack_addresses_shared_1 = require("./services/pge/electrack-addresses/electrack-addresses.shared");
const electrack_maps_shared_1 = require("./services/pge/electrack-maps/electrack-maps.shared");
const estimated_costs_shared_1 = require("./services/pge/estimated-costs/estimated-costs.shared");
const event_types_shared_1 = require("./services/pge/event-types/event-types.shared");
const events_shared_1 = require("./services/pge/events/events.shared");
const files_shared_1 = require("./services/pge/files/files.shared");
const menus_shared_1 = require("./services/pge/menus/menus.shared");
const order_products_shared_1 = require("./services/pge/order-products/order-products.shared");
const order_qtys_shared_1 = require("./services/pge/order-qtys/order-qtys.shared");
const orders_shared_1 = require("./services/pge/orders/orders.shared");
const parties_shared_1 = require("./services/pge/parties/parties.shared");
const products_shared_1 = require("./services/pge/products/products.shared");
const user_groups_shared_1 = require("./services/pge/user-groups/user-groups.shared");
const users_shared_1 = require("./services/pge/users/users.shared");
// PGI
const epms_production_shared_1 = require("./services/pgi/epms-production/epms-production.shared");
const epms_schedule_shared_1 = require("./services/pgi/epms-schedule/epms-schedule.shared");
const epms_schedule_process_shared_1 = require("./services/pgi/epms-schedule-process/epms-schedule-process.shared");
const menus_shared_2 = require("./services/pgi/menus/menus.shared");
const user_groups_shared_2 = require("./services/pgi/user-groups/user-groups.shared");
const users_shared_2 = require("./services/pgi/users/users.shared");
const authentication_client_1 = __importDefault(require("@feathersjs/authentication-client"));
const feathers_1 = require("@feathersjs/feathers");
/**
 * Returns a typed client for the feathers app.
 *
 * @param connection The REST or Socket.io Feathers client connection
 * @param authenticationOptions Additional settings for the authentication client
 * @see https://dove.feathersjs.com/api/client.html
 * @returns The Feathers client application
 */
// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
const createClient = (connection, authenticationOptions = {}) => {
    const client = (0, feathers_1.feathers)();
    client.configure(connection);
    client.configure((0, authentication_client_1.default)(authenticationOptions));
    client.set('connection', connection);
    // CC
    client.configure(auth_management_shared_1.ccAuthManagementClient);
    client.configure(ballots_shared_1.ccBallotsClient);
    client.configure(barcode_shared_1.ccBarcodeClient);
    client.configure(districts_shared_1.ccDistrictsClient);
    client.configure(election_matrixes_shared_1.ccElectionMatrixesClient);
    client.configure(election_metrics_shared_1.ccElectionMetricsClient);
    client.configure(electrack_shared_1.ccElectrackClient);
    client.configure(epms_component_shared_1.ccEpmsComponentClient);
    client.configure(epms_order_shared_1.ccEpmsOrderClient);
    client.configure(epms_shipment_shared_1.ccEpmsShipmentClient);
    client.configure(file_maker_shared_1.ccFileMakerClient);
    client.configure(file_uploads_shared_1.ccFileUploadsClient);
    client.configure(inventory_shared_1.ccInventoryClient);
    client.configure(lockouts_shared_1.ccLockoutsClient);
    client.configure(reports_shared_1.ccReportsClient);
    // EPMS
    client.configure(contact_shared_1.epmsContactClient);
    client.configure(cost_center_shared_1.epmsCostCenterClient);
    client.configure(customer_shared_1.epmsCustomerClient);
    client.configure(customer_ship_to_shared_1.epmsCustomerShipToClient);
    client.configure(department_shared_1.epmsDepartmentClient);
    client.configure(diary_note_shared_1.epmsDiaryNoteClient);
    client.configure(employee_shared_1.epmsEmployeeClient);
    client.configure(estimate_header_shared_1.epmsEstimateHeaderClient);
    client.configure(location_shared_1.epmsLocationClient);
    client.configure(material_on_hand_shared_1.epmsMaterialOnHandClient);
    client.configure(order_component_shared_1.epmsOrderComponentClient);
    client.configure(order_header_shared_1.epmsOrderHeaderClient);
    client.configure(order_process_shared_1.epmsOrderProcessClient);
    client.configure(production_shared_1.epmsProductionClient);
    client.configure(production_job_number_shared_1.epmsProductionJobNumberClient);
    // ET
    client.configure(audit_shared_1.etAuditClient);
    client.configure(counties_shared_1.etCountiesClient);
    client.configure(elections_shared_1.etElectionsClient);
    client.configure(jobs_shared_1.etJobsClient);
    client.configure(maps_shared_1.etMapsClient);
    // PGE
    client.configure(activity_logs_shared_1.pgeActivityLogsClient);
    client.configure(app_settings_shared_1.pgeAppSettingsClient);
    client.configure(ballot_types_shared_1.pgeBallotTypesClient);
    client.configure(district_sheets_shared_1.pgeDistrictSheetsClient);
    client.configure(districts_shared_2.pgeDistrictsClient);
    client.configure(election_ballots_shared_1.pgeElectionBallotsClient);
    client.configure(election_matrixes_shared_2.pgeElectionMatrixesClient);
    client.configure(election_parties_shared_1.pgeElectionPartiesClient);
    client.configure(elections_shared_2.pgeElectionsClient);
    client.configure(electrack_addresses_shared_1.pgeElectrackAddressesClient);
    client.configure(electrack_maps_shared_1.pgeElectrackMapsClient);
    client.configure(estimated_costs_shared_1.pgeEstimatedCostsClient);
    client.configure(event_types_shared_1.pgeEventTypesClient);
    client.configure(events_shared_1.pgeEventsClient);
    client.configure(files_shared_1.pgeFilesClient);
    client.configure(menus_shared_1.pgeMenusClient);
    client.configure(order_products_shared_1.pgeOrderProductsClient);
    client.configure(order_qtys_shared_1.pgeOrderQtysClient);
    client.configure(orders_shared_1.pgeOrdersClient);
    client.configure(parties_shared_1.pgePartiesClient);
    client.configure(products_shared_1.pgeProductsClient);
    client.configure(user_groups_shared_1.pgeUserGroupsClient);
    client.configure(users_shared_1.pgeUsersClient);
    // PGI
    client.configure(epms_production_shared_1.pgiEpmsProductionClient);
    client.configure(epms_schedule_process_shared_1.pgiEpmsScheduleProcessClient);
    client.configure(epms_schedule_shared_1.pgiEpmsScheduleClient);
    client.configure(menus_shared_2.pgiMenusClient);
    client.configure(user_groups_shared_2.pgiUserGroupsClient);
    client.configure(users_shared_2.pgiUsersClient);
    return client;
};
exports.createClient = createClient;
